var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "TheSearchAI",
      class: _vm.bemBlockMod({
        open: _vm.openModal
      }),
      attrs: { id: "vuethesearch" }
    },
    [
      _vm.showInputSpan
        ? _c(
            "BaseVueTyper",
            _vm._b(
              {
                class: _vm.bemElement("input"),
                on: { "input-click": _vm.show }
              },
              "BaseVueTyper",
              _vm.vueTyperData,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.showsModalOpen || _vm.showInputSpan) &&
      _vm.tooltipData.tooltipEnabled
        ? _c(
            "BaseTooltip",
            _vm._b(
              {
                attrs: { "call-close-event": _vm.openModal === true },
                on: {
                  "tooltip-show": _vm.onToolTipShow,
                  "tooltip-hide": _vm.onToolTipHide,
                  "tooltip-click": _vm.onToolTipClick
                }
              },
              "BaseTooltip",
              _vm.tooltipConfig,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imageSearchEnabled && _vm.showInputSpan
        ? _c("BaseImageSearch", { class: _vm.bemElement("image-search") })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "BaseModal",
        {
          attrs: {
            bem: "the-search-ai-modal",
            "is-open": _vm.openModal,
            "modal-modifier": "fullscreen",
            "show-backdrop": true
          },
          on: { closed: _vm.hide }
        },
        [
          _vm.openModal
            ? _c("BasePageRender", {
                attrs: {
                  "page-id": _vm.pageId,
                  "query-parameters": _vm.searchQuery
                    ? {
                        searchQuery: _vm.searchQuery
                      }
                    : {},
                  "search-prop": {
                    defaults: {
                      hidden: false,
                      interacting: false,
                      infiniteScrollWrapper: ".the-search-ai-modal__body",
                      value: ""
                    },
                    searchSource: _vm.searchSource
                  }
                },
                on: { "on-loaded": _vm.handlerAnalytics }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }